import { useContext } from "react";
import { UploadInvoiceActionContext } from "./UploadInvoiceActionContext";

function usePrepareUploadInvoice() {
  const {setElement,  setElementId, setShowModal, setBackendFormErrors} = useContext(UploadInvoiceActionContext);
  return (id: any) => {
    setElementId(id);        
    setElement(null);
    setShowModal(true)
    setBackendFormErrors(null)
  }
}

export default usePrepareUploadInvoice;
